(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charme-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class CharmeHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-charme-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-charme-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-charme-hero-dot]'));
      this.previousButton = this.querySelector('[data-charme-hero-prev]');
      this.nextButton = this.querySelector('[data-charme-hero-next]');
      this.currentIndex = 0;
      this.interval = null;
      this.dragStart = null;
      this.dragDelta = 0;

      if (!this.track || this.slides.length < 2) return;

      this.setSlide(0, false);
      this.bindEvents();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    bindEvents() {
      this.previousButton?.addEventListener('click', () => this.go(-1));
      this.nextButton?.addEventListener('click', () => this.go(1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.stopAutoplay();
          this.setSlide(Number(dot.dataset.charmeHeroDot));
          this.startAutoplay();
        });
      });

      this.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.addEventListener('pointerup', () => this.onPointerUp());
      this.addEventListener('pointercancel', () => this.onPointerUp());
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }

    go(direction) {
      this.stopAutoplay();
      this.setSlide(this.currentIndex + direction);
      this.startAutoplay();
    }

    setSlide(index, animate = true) {
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.track.style.transitionDuration = animate ? '' : '0ms';
      this.track.style.transform = `translate3d(${-100 * this.currentIndex}%, 0, 0)`;

      this.slides.forEach((slide, slideIndex) => {
        slide.toggleAttribute('inert', slideIndex !== this.currentIndex);
        slide.setAttribute('aria-hidden', String(slideIndex !== this.currentIndex));
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });

      if (!animate) {
        requestAnimationFrame(() => {
          this.track.style.transitionDuration = '';
        });
      }
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAutoplay();
      this.interval = window.setInterval(() => this.setSlide(this.currentIndex + 1), Number(this.dataset.autoplaySpeed) || 5000);
    }

    stopAutoplay() {
      window.clearInterval(this.interval);
      this.interval = null;
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.dragStart = event.clientX;
      this.dragDelta = 0;
      this.stopAutoplay();
    }

    onPointerMove(event) {
      if (this.dragStart === null) return;
      this.dragDelta = event.clientX - this.dragStart;
    }

    onPointerUp() {
      if (this.dragStart === null) return;
      if (Math.abs(this.dragDelta) > 42) {
        this.setSlide(this.currentIndex + (this.dragDelta < 0 ? 1 : -1));
      }
      this.dragStart = null;
      this.dragDelta = 0;
      this.startAutoplay();
    }
  }

  if (!customElements.get('charme-hero-slider')) {
    customElements.define('charme-hero-slider', CharmeHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
